module.exports = __webpack_public_path__ + "static/algebra-prep-a5c48d65b1fa4c2f42356d2021cd5678.jpg";